// extracted by mini-css-extract-plugin
export default {"ImagePreview":"DocumentPreview_ImagePreview__uAHyj"};